export default {
    state: {
        items: [],
    },
    // Única forma de alterar uma variável é através das mutations
    mutations: {
        ADD_ITEM(state, item) {
            const valueIsAlreadyAdded = state.items.find(goal => {
                return goal.id == item.id
            })
            if (!valueIsAlreadyAdded) {
                state.items.push(item)
            }
        },
        REMOVE_ITEM(state, item) {
            state.items = state.items.filter(goal => {
                return goal.id != item.id
            })
        },
        CLEAR(state) {
            state.items = []
        },
    },
    actions: {
        clear(context) {
            context.commit('CLEAR')
        },
        loadItems(context, items) {
            items.forEach(item => {
                context.commit('ADD_ITEM', item)
            })
        },
        loadItem(context, item) {
            context.commit('ADD_ITEM', item)
        },
        removeItem(context, item) {
            context.commit('REMOVE_ITEM', item)
        },
        removeItems(context, items) {
            items.forEach(item => {
                context.commit('REMOVE_ITEM', item)
            })
        },
    },
}
